import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';

const StatsSection = () => {
  const [counters, setCounters] = useState({
    years: 0,
    hours: 0,
    retention: 0
  });

  useEffect(() => {
    // Animate counters
    const duration = 2000;
    const steps = 60;
    const interval = duration / steps;

    const targets = {
      years: 20,
      hours: 12,
      retention: 90
    };

    let step = 0;
    const timer = setInterval(() => {
      step++;
      setCounters({
        years: Math.floor((targets.years / steps) * step),
        hours: Math.floor((targets.hours / steps) * step),
        retention: Math.floor((targets.retention / steps) * step)
      });

      if (step >= steps) {
        clearInterval(timer);
        setCounters(targets);
      }
    }, interval);

    return () => clearInterval(timer);
  }, []);

  const scrollToPlans = () => {
    const plansSection = document.getElementById('planos');
    if (plansSection) {
      plansSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="bg-white py-20 overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Column - Image */}
          <div className="relative scroll-reveal-left">
            <div className="relative w-full max-w-md mx-auto aspect-[3/4] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="/images/bruno-diferencia.jpg"
                alt="Bruno Rodrigues"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right Column - Text and Stats */}
          <div className="space-y-8 text-center md:text-left scroll-reveal-right">
            <div className="space-y-6">
              <p className="text-lg md:text-xl text-gray-600 italic leading-relaxed">
                Para mim não és um número, és uma pessoa, uma história, e eu quero conhecê-la e ajudar-te.
              </p>

              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-black">
                O que nos <span className="text-[#fff301]">diferencia?</span>
              </h2>

              <div className="space-y-4 text-left">
                <div className="flex items-start gap-3">
                  <span className="text-red-500 text-xl md:text-2xl font-bold flex-shrink-0">✕</span>
                  <p className="text-base md:text-lg text-gray-700">Não somos só mais uma app</p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-red-500 text-xl md:text-2xl font-bold flex-shrink-0">✕</span>
                  <p className="text-base md:text-lg text-gray-700">Não recebemos o teu nome e mandamos um PDF genérico</p>
                </div>
              </div>

              <p className="text-lg md:text-xl font-bold text-black">
                Somos uma equipa que te acompanha de verdade.
              </p>
            </div>

            {/* Stats */}
            <div className="bg-gray-100 rounded-2xl p-6 md:p-8 grid grid-cols-3 gap-4 md:gap-6">
              <div className="text-center">
                <div className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-700 mb-1 md:mb-2">
                  +{counters.years}
                </div>
                <p className="text-xs md:text-sm text-gray-600 font-semibold">Anos</p>
                <p className="text-xs text-gray-500">De experiência comprovada em perda de peso saudável</p>
              </div>
              <div className="text-center border-l border-r border-gray-300">
                <div className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-700 mb-1 md:mb-2">+{counters.hours}K</div>
                <p className="text-xs md:text-sm text-gray-600 font-semibold">Horas</p>
                <p className="text-xs text-gray-500">De treinos dados</p>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-700 mb-1 md:mb-2">{counters.retention}%</div>
                <p className="text-xs md:text-sm text-gray-600 font-semibold">Taxa</p>
                <p className="text-xs text-gray-500">De retenção</p>
              </div>
            </div>

            {/* CTA Button */}
            <div className="flex justify-center md:justify-start">
              <Button
                onClick={scrollToPlans}
                className="bg-[#fff301] hover:bg-[#e6dd01] text-black font-semibold px-6 md:px-8 py-6 rounded-full text-base md:text-lg transition-all duration-300 hover:scale-105 shadow-lg"
              >
                Quero começar a minha transformação!
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
